<script>
export default {
    name: 'ContentAdviceBlock',
    props: {
        data: Object,
    },
};
</script>

<template>
    <div class="advice-block richtext">
        <div class="advice-block__item" v-for="(item, i) in data.items" v-bind:key="i">
            <svg class="advice-block__icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.3333 28.0001H18.6667M21.3333 16.0001C20.4444 16.889 20 18.6667 20 21.3334V22.6667H12V21.3334C12 18.6667 11.5556 16.889 10.6667 16.0001C7.56528 12.8987 7.21896 8.13409 10.3432 5.00989C13.4673 1.8857 18.5327 1.8857 21.6569 5.00989C24.7811 8.13409 24.5425 12.791 21.3333 16.0001Z" stroke="currentColor" stroke-linecap="square"/>
            </svg>
            <div class="text-block__content" v-html="item.text"></div>
        </div>
    </div>
</template>

<style lang="scss">
.advice-block__item {
    display: flex;
    align-items: flex-start;
    gap: 2.6rem;

    @include breakpoint('xs') {
        gap: 1.8rem;
    }
}

.advice-block__icon {
    flex: 0 0 3.2rem;

    @include breakpoint('xs') {
        flex: 0 0 2.8rem;
    }
}

</style>
